import React from 'react';
import PropTypes from 'prop-types';
import Async from 'react-select/async';
import { components } from 'react-select';
import axios from 'axios';

import { ucwords } from '../../lib/strings';

const UserSelect = ({
  value,
  userType,
  onChange,
  isMulti = false,
  showDefaultOptions = false,
  style = {},
}) => {
  const Input = (props) => {
    return <components.Input {...props} />;
  };

  const Option = (props) => {
    const record = props.data.record;
    // The parent scopes by userType, so showing it on every row is just noise
    // ("Provider" under each row in a Provider picker). Only show the type
    // when the dropdown is unfiltered (cross-type search).
    return (
      <components.Option {...props}>
        <p className="mb-0">{props.children}</p>
        {!userType && (
          <small className="text-muted">{ucwords(record.userType)}</small>
        )}
      </components.Option>
    );
  };

  const loadOptions = async (term) => {
    // assignable=true: users flagged userAssignable=false (people who must
    // never be assigned work, e.g. the CEO) are hidden from every picker
    // built on this component. Clients all default true, so this only
    // bites for deliberately-flagged internal users.
    const endpoint = `/users?search=${term}&userType=${userType}&limit=500&assignable=true`;
    const results = await axios.get(endpoint);
    const opts = results.data.rows.map((item) => {
      return {
        value: item.userId,
        label: `${item.userLastName}, ${item.userFirstName}`,
        record: item,
      };
    });

    return opts;
  };
  return (
    <Async
      components={{ Option, Input }}
      isMulti={isMulti}
      isClearable={true}
      isSearchable={true}
      loadOptions={loadOptions}
      onChange={onChange}
      value={value}
      defaultOptions={showDefaultOptions}
      styles={style}
    />
  );
};

UserSelect.propTypes = {
  value: PropTypes.any,
  userType: PropTypes.string.isRequired,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showDefaultOptions: PropTypes.bool,
  style: PropTypes.object,
};

export default UserSelect;
